import { CardMedia, CardContent, Typography } from '@mui/material'
import { HBCard, CardListItem, DeclineCardImageContainer } from './CardStyles'
import { DeclinePNG } from './Icons'

const DeclineCard = ({ size }: { size?: 'small' | 'large' }): JSX.Element => {
  return (
    <CardListItem size={size}>
      <HBCard>
        <DeclineCardImageContainer>
          <CardMedia
            aria-hidden='true'
            component='img'
            height={size === 'small' ? '214' : '224'}
            src={`data:image/png;base64, ${DeclinePNG}`}
            style={{
              objectFit: 'contain',
              objectPosition: 'bottom',
              borderRadius: '8px',
            }}
          />
        </DeclineCardImageContainer>
        <CardContent
          style={{
            padding: '16px 0',
            margin: '0 auto',
            textAlign: 'center',
            maxWidth: '310px',
          }}
        >
          <Typography fontSize='1.1rem' variant='h3' fontWeight={600}>
            {`Don't like these options?`}
          </Typography>
          <Typography fontSize='1.1rem' variant='body1' fontWeight={500}>
            {`Decline some to open slots for new venues to message you.`}
          </Typography>
        </CardContent>
      </HBCard>
    </CardListItem>
  )
}

export default DeclineCard
